<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="equipo.nombre" />
            </div>
            <div class="col-12" v-if="representantes">
                <label>Representantes</label>
                <ValidationProvider name="representante" id="representante" rules="required" v-slot="{ errors }">
                    <multiselect 
                        v-model="equipo.representante"
                        id="representante"
                        placeholder="Representante"
                        :class="'mb-3 ' + (errors[0] ? 'is-invalid' : '')"
                        label="name"
                        track-by="id"
                        :options="representantes">
                    </multiselect>
                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="col-12">
                <label>
                    Imagen del equipo <b>(MEDIDAS: 1020X340 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB)</b>
                </label>
                <div class="text-center" v-if="equipo.imagen">
                    <template>
                        <br>
                        <img :src="equipo.imagen_formatted" style="max-height: 200px">
                        <br>
                        <Button class="mt-3" @click="imagenBorrada()">Borrar</Button>
                    </template>
                </div>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="340"
                        :width="1020"
                        @success="imagenSubida"
                    />
                </template>
            </div>
            <div class="col-12 text-right mt-3">
                <Button type="submit" name="button" :disabled="loading">GUARDAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import Dropzone from '@/components/common/Dropzone';

export default {
    props: ['equipo'],
    data() {
        return {
            loading: false,
            imagen: null,
            index: 0,
            representantes: null,
            url: this.config.API_BASE + '/upload/image-equipo?api_key=' + localStorage.getItem('token') + '&permisos=public'
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.guardar();
            }
        },
        imagenBorrada() {
            this.equipo.imagen = '';          
        },
        imagenSubida(file, response) {
            this.imagen = response;
        },
        guardar() {
            if (this.imagen) {
                this.equipo.imagen = this.imagen;
            }
            this.$emit('terminado');
        },
        getRepresentantes() {
            let params = {
                lista_id: this.lista_id,
                filters: {}
            }

            this.$store.dispatch(this.config.getVuexAlias('back.bases.get.representantes'), params).then(res => {
                this.representantes = res.data.representantes;
            });
        }
    },
    computed: {
        lista_id() {
            return this.$route.params.lista_id;
        }
    },
    created() {
        this.getRepresentantes();
    },
    components: {
        Dropzone
    }
}
</script>